import { Button, CircularProgress, Grid, Stack, Typography } from '@mui/material'
import { ControlledTextArea } from '../../../components/forms/input/ControlledTextArea'
import { useForm } from 'react-hook-form'
import DoneIcon from '@mui/icons-material/Done';
import { CancelModel } from '../../../components/modal/CancelModal'
import { useEffect, useState } from 'react'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { endpoints } from '../../../api/endpoints';
import { toast } from 'react-toastify';
import { useCrudForm } from '../../../api/useCrudForm';

const CustomerRejectForm = ({ selectedItem, setOpen, setIsReject }: { selectedItem: any, setOpen: (value: boolean) => void, setIsReject: (value: boolean) => void }) => {
  const cancelMessage = 'Cancel current unsaved changes and go back to customer detail?'
  const [isLoading, setIsLoading] = useState(false)
  const { handleSubmit, control, setValue, formState: { errors, } } = useForm<valuesTypes>(
    {
      resolver: yupResolver(CustomerRejectSchema),
      defaultValues: { id: '', remarks: '' }
    })

  const { edit } = useCrudForm()

  const onSubmit = (values: any) => {
    setIsLoading(true)
    edit({
      endpoints: `${endpoints.customer.reject}`,
      onSuccess: (data: any) => {
        toast.success(data.message, { style: { background: '#3150A1' } })
        setIsLoading(false)
        handleClose()
        setIsReject(true)
      },
      onError: (error: any) => {
        handleClose()
        setIsLoading(false)
        toast.error(error)
      },
      values: values
    })
  }

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (selectedItem) {
      setValue('id', selectedItem?.tempid ?? selectedItem?.id)
      setValue('remarks', selectedItem?.remarks)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Typography component={'p'} mt={2} mb={2}>Reject Information</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} >
          <ControlledTextArea name={`remarks`} control={control} errors={errors} label="Remarks" />
        </Grid>

      </Grid>
      <Stack direction='row' justifyContent='flex-end' spacing={3} mt={5}>
        <CancelModel handleModalClose={handleClose} message={cancelMessage} />
        <Button onClick={(e) => { e.preventDefault(); handleSubmit(onSubmit)() }} variant='contained' sx={{ color: '#3150A1' }} disabled={isLoading}>
          <Stack direction='row' spacing={2}>
            {
              isLoading ? <CircularProgress size={20} color="inherit" /> : <DoneIcon sx={{ color: 'white' }} />
            }
            <Typography sx={{ color: isLoading ? 'gray' : 'white' }}>
              Submit
            </Typography>
          </Stack>
        </Button>
      </Stack>
    </>
  )
}

export default CustomerRejectForm

export type valuesTypes = {
  id: string,
  remarks: string
}

const CustomerRejectSchema = yup.object().shape({
  remarks: yup.string().typeError('Remarks is required').required('Remarks is required'),
})